import { render, staticRenderFns } from "./NovaFilial.vue?vue&type=template&id=43baead2"
import script from "./NovaFilial.vue?vue&type=script&lang=js"
export * from "./NovaFilial.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports